import React from 'react';
import { OrientationRadioGroup } from '../../ChartOptions/Legend/LegendComponents/OrientationRadioGroup';
import { ALIGN_OPTIONS, JUSTIFY_OPTIONS } from './ButtonContent.constants';

interface AlignmentControlsProps {
  type: 'text' | 'icon' | 'image';
  currentProps: any;
  updateProps: (updates: any) => void;
  isMultiContent?: boolean;
  iconColor?: string;
}

//alignment controlls for button elements
const AlignmentControls: React.FC<AlignmentControlsProps> = ({
  type,
  currentProps,
  updateProps,
  isMultiContent,
  iconColor,
}) => {
  const disableHorizontalAlignment = isMultiContent && (type === 'icon' || type === 'image');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '5px' }}>
      <div>
        <div className="optionDescription" style={{ marginTop: '3px', color: iconColor }}>
          Vertical Alignment
        </div>
        <OrientationRadioGroup
          orientation={currentProps.alignSelf || 'center'}
          options={ALIGN_OPTIONS}
          onChange={(key) => updateProps({ alignSelf: key })}
        />
      </div>
      <div>
        <div
          className="optionDescription"
          style={{
            marginBottom: '3px',
            marginTop: '3px',
            color: disableHorizontalAlignment ? '#999' : iconColor, // Gray out if disabled
          }}
        >
          Horizontal Alignment
        </div>
        <OrientationRadioGroup
          orientation={currentProps.justifySelf || 'center'}
          options={JUSTIFY_OPTIONS}
          onChange={(key) => !disableHorizontalAlignment && updateProps({ justifySelf: key })}
          disabled={disableHorizontalAlignment} // Disable interaction
          style={{
            opacity: disableHorizontalAlignment ? 0.6 : 1, // Gray out appearance
            pointerEvents: disableHorizontalAlignment ? 'none' : 'auto', // Prevent clicks
          }}
        />
      </div>
    </div>
  );
};

export default AlignmentControls;
